'use strict';

const Alerts = require('lib/alerts');
var template = require('../../templates/employee/LayoutHeader.ejs');
var loader   = require('helpers/loader');
const InviteMessage = require('../../templates/InviteMessage.ejs');

import localStorageUtil from 'helpers/localStorageUtil.js';

module.exports = Backbone.View.extend({

    events: {
        'click .js-send-welcome-email': 'onSendEmail',
        'click .js-change-image-link': 'onChangeImage',
        'click .js-change-employee': 'onChangeEmployee',
        'change .js-change-image-input': 'uploadImage'
    },

    onSendEmail: function() {
        var stopLoader = loader.startFullScreen('.btn-invite-employee');
        this.model.invite()
            .then(() => {
                Alerts.show('success', {
                    text: InviteMessage()
                });
            })
            .catch((payload) => {
                if (payload.message && payload.message.error) {
                    Alerts.show('error', {
                        text: payload.message.error.message
                    });
                } else {
                    Alerts.show('error', {text: payload});
                }
            })
            .finally(stopLoader);
    },

    onChangeImage: function() {
        this.$('.js-change-image-input').click();
    },

    uploadImage: function(e) {
        const selectedFile = this.$(e.currentTarget)[0].files[0];

        const self = this;
        const stopLoader = loader.startFullScreen();

        return self.model.uploadImage(selectedFile)
            .then(() => {
                self.render();
            }).catch(err => { Alerts.show('criticalError', err); })
            .finally(stopLoader);
    },

    render: function() {
        var options = {
            imageUrl: '',
            fullName: '',
            nameAbbreviation: '',
            email: '',
            profileProgress: 0,
            sendButton: false,
            tab: this.tab
        };

        if (this.model) {
            options.imageUrl = this.model.getImageUrl() || '';
            options.fullName = this.model.get('fullName');
            options.nameAbbreviation =
                (this.model.has('imageUrl') ||
                this.model.has('tempImageUrl')) ? '' :
                this.model.getNameAbbreviation();
            options.email = this.model.get('email');
            options.profileProgress = this.model.calculateProfileProgress();
            options.sendButton = (
                this.model.get('email') &&
                !_.contains(this.model.dirtyKeys(), 'email')
            );
        }

        if (this.model && this.collection && !this.model.isNew()) {
            var ids = _.pluck(this.collection.models, 'id');
            var index = ids.indexOf(this.model.id);
            options.next = ids[index + 1];
            options.prev = ids[index - 1];
        } else {
            options.next = false;
            options.prev = false;
        }

        this.$el.html(template(options));
    },

    setModel: function(model) {
        if (this.model) {
            this.model.off('change sync', this.render, this);
        }
        this.model = model;
        if (this.model) {
            this.model.on('change sync', this.render, this);
            this.render();
        }
    },

    setCollection: function(collection) {
        this.collection = collection;
        if (this.collection) {
            this.render();
        }
    },

    onChangeEmployee: function() {
        localStorageUtil.removeItem('ytdYear');
    }

});



// WEBPACK FOOTER //
// ./app/employer/views/employee/LayoutHeader.js